/**
 * HealthQuizDecoIcon — sanitized from `assets/newSvg/health-quiz-deco.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function HealthQuizDecoIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M3,5 C3,3.89543 3.89543,3 5,3 L19,3 C20.1046,3 21,3.89543 21,5 L21,19 C21,20.1046 20.1046,21 19,21 L5,21 C3.89543,21 3,20.1046 3,19 L3,5 Z M13.9389,7.6547 C13.5859,6.77223 12.3206,6.82154 12.0371,7.72855 L10.2853,13.3345 L9.89719,12.5583 C9.72611,12.2161 9.37639,12 8.99382,12 L7,12 C6.44772,12 6,12.4477 6,13 C6,13.5523 6.44772,14 7,14 L8.38197,14 L9.59448,16.425 C10.001,17.2381 11.1907,17.1422 11.4619,16.2746 L13.1158,10.9821 L14.069,13.3651 C14.2224,13.7486 14.5938,14 15.0068,14 L17,14 C17.5523,14 18,13.5523 18,13 C18,12.4477 17.5523,12 17,12 L15.677,12 L13.9389,7.6547 Z"
        fill={color}
      />
    </Svg>
  );
}

export default HealthQuizDecoIcon;
